import { render, staticRenderFns } from "./Doughnut.vue?vue&type=template&id=785b32aa"
import script from "./Doughnut.vue?vue&type=script&lang=js"
export * from "./Doughnut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports